import React from 'react';
import DataTable from 'react-data-table-component';
import HighlightBanner from '../../components/HighlightedBanner/HighlightBanner';
import { columns } from './_components/columns';
import { Actions } from './_components/actions';
import { jdsTableStyles } from '../../components/jds/tableStyles';
import { JdsPagination } from '../../components/jds/JdsPagination';
import '../../components/jds/jds.css';
import { useItemsBootstrap } from './items.bootstrap.hook';

export function Items() {
  const {
    data,
    loading,
    errorMessage,
    totalRows,
    perPage,
    currentPage,
    filterText,
    resetPaginationToggle,
    handlePageChange,
    handlePerRowsChange,
    handleFilterChange,
    handleRowClicked,
  } = useItemsBootstrap();

  return (
    <div className="items-page jds-scope">
      <div className="row mb-10">
        <div className="col-xl-12">
          <section className="jds-card">
            {errorMessage && (
              <div className="mb-6">
                <HighlightBanner type="error">{errorMessage}</HighlightBanner>
              </div>
            )}

            <div className="items-table-shell">
              <DataTable
                columns={columns}
                data={data}
                onRowClicked={handleRowClicked}
                highlightOnHover
                pointerOnHover
                customStyles={jdsTableStyles}
                progressPending={loading}
                pagination
                paginationPerPage={perPage}
                paginationDefaultPage={currentPage}
                paginationServer
                paginationTotalRows={totalRows}
                paginationResetDefaultPage={resetPaginationToggle}
                paginationComponent={JdsPagination}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                subHeader
                subHeaderComponent={
                  <Actions
                    filterText={filterText}
                    onFilter={handleFilterChange}
                  />
                }
                persistTableHead
                responsive
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
